<template>
  <div>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-9 col-md-12">
          <div class="card mb-3" >
            <div class="card-header">
                <h3 class="mb-0">Auto FX between your account</h3>
              </div>

            <div class="card-body min-vh" v-loading="loading">
              <div class="mb-4">
                <CompareCurrency ref="comparecurrency" :swapbutton="false" theme="light" type="plus" :currencies="curencies"/>
              </div>
              
              <div class="row justify-content-md-center" v-if="serviceInfo && serviceInfo.serviceactive">
                <div class="col-lg-8 col-md-12">

                  

                  <el-form ref="formAutoFX" :model="form" :rules="formRule" :label-position="labelPosition" label-width="150px">
                    
                    <el-form-item label="From BankholderID" prop="from_bankholderid">
                      <el-select v-model="form.from_bankholderid" @change="getBalanceFrom" placeholder="From BankholderID" class="form-control-alternative">
                        <el-option v-for="item of bankAccount" :key="item.uid" :label="`${item.currency} (${item.cardholderid})`" :value="item.cardholderid"></el-option>
                      </el-select>
                      <div class="text-xs pl-3 mt-1" v-loading="loadingBalanceFrom">{{ balanceFrom }}</div>
                    </el-form-item>

                    <el-form-item label="To BankholderID" prop="to_bankholderid">
                      <el-select v-model="form.to_bankholderid" @change="getBalanceTo" placeholder="To BankholderID" class="form-control-alternative">
                        <el-option v-for="item of bankAccount" :key="item.uid" :label="`${item.currency} (${item.cardholderid})`" :value="item.cardholderid"></el-option>
                      </el-select>
                      <div class="text-xs pl-3 mt-1" v-loading="loadingBalanceTo">{{ balanceTo }}</div>
                    </el-form-item>

                    <el-form-item label="Amount" prop="amount">
                      <el-input type="number" v-model="form.amount" @input="amountEnter" class="form-control-alternative"></el-input>
                    </el-form-item>

                    <div>
                    <QuoteButton
                      ref="quotebtn"
                      :customertype="isBusiness ? 'corp' : 'plus'"
                      :from="wallet_from_currency"
                      :to="wallet_to_currency"
                      :amount="form.amount"
                      :fx="true"
                      @onQuoted="onQuoted"
                      @onTimeout="onTimeout"
                    />
                  </div>

                  </el-form>
                </div>
              </div>

              <div class="row justify-content-md-center"  v-if="serviceInfo && !serviceInfo.serviceactive">
                <div class="col-lg-12 col-md-12 text-center">
                  <img :src="'/img/brand/logo.png'" class="navbar-brand-img" alt="logo" width="320px" />
                  <div v-if="serviceInfo.reasontype === 'other'">
                    <h1 class="mt-5">{{ serviceInfo.reason }}</h1>
                  </div>
                  <div v-if="serviceInfo.reasontype === 'closed'">
                    <h1 class="mt-5">Services is unavailable during the office closed</h1>
                    <h3>Please used this function between 9.00-17.00 between Monday - Friday</h3>
                  </div>
                  <div v-if="serviceInfo.reasontype === 'holiday'">
                    <h1 class="mt-5">Service is unavailable during the bank holiday</h1>
                    <h3>Please used this function between 9.00-17.00 between Monday - Friday</h3>
                  </div>
                  <div v-if="serviceInfo.reasontype === 'maintenance'">
                    <h1 class="mt-5">Service is unavailable during the maintenance time.</h1>
                    <h3>Please try again letter or contact us at 0203 355 9660</h3>
                  </div>
                  
                </div>
              </div>
             
            </div>
            <div class="card-footer" v-if="serviceInfo && serviceInfo.serviceactive">
              <div class="row justify-content-xl-center">
                <div class="col-xl-12 text-center">
                  <el-button @click="amountEnter">Cancel</el-button>
                  <el-button type="primary" @click="onSubmit()" :disabled="sameAccount" v-loading="submiting">Confirm</el-button>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-xl-3 col-md-12">
          <div class="card mb-3">
              <div class="card-body">
                <Shortcut/>
              </div> 
          </div>

        </div>
      </div>
    </div>
    <ReviewRateDialog ref="reviewratedialog"/>
  </div>
</template>
<script>
import FxApi from '@/api/fx' 
import Utils from '@/utils'
import BankApi from '@/api/bankaccount'
import { isMobile } from "@/utils/helpers";
import Shortcut from '@/components/MenuShortcut.vue'
import QuoteButton from "@/views/Wallet/components/QuoteButton.vue";
import CompareCurrency from '@/components/Chart/CompareCurrency';
import ReviewRateDialog from '@/components/Review/Review'
export default {
  components: {
    Shortcut,
    QuoteButton,
    CompareCurrency,
    ReviewRateDialog
  },
  computed: {
    isBusiness(){
      return this.$store.getters.business
    },
    labelPosition() {
      return isMobile() ? "top" : "left";
    },

  },
  data(){
    return {
      sameAccount: false,
      submiting: false,
      submitingQuote: false,
      loading: false,
      bankAccount: [],
      balanceFrom: "",
      loadingBalanceFrom: false,
      balanceTo: "",
      loadingBalanceTo: false,
      wallet_from_currency: "",
      wallet_to_currency: "",
      serviceInfo: null,
      form: {
        from_bankholderid: "",
        to_bankholderid: "",
        amount: "",
        qoutetoken: "",
        verifytoken: "",
        calresponse: {}
      },
      formRule:{
        from_bankholderid: [{required: true, message: "Please select from BankholderID", trigger: "blur"}],
        to_bankholderid: [{required: true, message: "Please select to BankholderID", trigger: "blur"}],
        amount: [{required: true, message: "Please enter amount", trigger: "blur"}]
      },
      curencies:[]
    }
  },
  methods:{
    async getBankAccount(){
      this.balanceFrom = ""
      this.balanceTo = ""
      this.loading = true;
      this.bankAccount = await Utils.getBankAccount()
      this.loading = false
      this.getBankCurrency();
    },
    getBankCurrency() { 
      this.bankAccount.forEach((item) => { 
        if (!this.curencies.includes(item.currency)) { 
          this.curencies.push(item.currency);
        }
      });
    },
    checkSameAccount(){
      const fromCurrency = Utils.findObject(this.bankAccount, this.form.from_bankholderid, 'cardholderid')
      const toCurrency = Utils.findObject(this.bankAccount, this.form.to_bankholderid, 'cardholderid')
      this.amountEnter();

      this.wallet_from_currency = fromCurrency? fromCurrency['currency'] : ""
      this.wallet_to_currency = toCurrency ? toCurrency['currency'] : ""

      if((fromCurrency && fromCurrency['currency']) === (toCurrency && toCurrency['currency'])){
        this.form.from_bankholderid = ""
        this.form.to_bankholderid = ""
        this.balanceFrom = ""
        this.balanceTo = ""
        this.$swal('Message', "FX not allow for same currency", 'error')
        this.sameAccount = true;
        return false
      }

      this.sameAccount = false;
      return true;
    },
    getBalanceFrom(bankholderid){
      this.balanceFrom = ""
      if(!this.checkSameAccount()) return false
      this.$refs.comparecurrency.changeFrom(this.wallet_from_currency);
      this.loadingBalanceFrom = true
      BankApi.getAccountBalance(bankholderid).then(({result, data})=>{
        this.loadingBalanceFrom = false
        if(result){
          this.balanceFrom = `Balance : ${data.balance}`
        }
      })
    },
    getBalanceTo(bankholderid){
      this.balanceTo = ""
      if(!this.checkSameAccount()) return false
      this.$refs.comparecurrency.changeTo(this.wallet_to_currency);
      this.loadingBalanceTo = true
      BankApi.getAccountBalance(bankholderid).then(({result, data})=>{
        this.loadingBalanceTo = false
        if(result){
          this.balanceTo = `Balance : ${data.balance}`
        }
      })
    },
    amountEnter() {
      this.$refs.quotebtn.clearTimer();
    },
    onQuoted(data) {
      this.form.verifytoken = data["verifytoken"];
      this.form.qoutetoken = data["qoutetoken"];
      this.form.calresponse = data["response"];
      this.quoted = true;
      this.$refs.comparecurrency.getRate()
      
    },
    onTimeout() {
      this.quoted = false;
    },
  
    onSubmit(){
      this.$refs.formAutoFX.validate(valid=>{
        if(valid){
          this.submiting = true
          this.form.amount = parseFloat(this.form.amount)
          FxApi.autoFX(this.form).then(({result, message})=>{
            this.submiting = false
            this.amountEnter()
            if(result){
              this.$swal(`Message`, `Auto FX between your account is success`, 'success').then(()=>{
                
                this.$refs.formAutoFX.resetFields()
                this.$emit("updateBalance");
                this.showReview();
              })
            }else{
              this.$swal('Message', message, 'error')
            }
          })
        }
      })
    },
    getServiceActive(){
      this.loading = true
      FxApi.serviceActive().then(async ({result, data})=>{
        this.loading = false
        if(result){
          this.serviceInfo = data
          if(data.serviceactive){
            await this.getBankAccount()
          }
        }
      })
    },
    showReview(){
      var paymentReceipt = {
        payment_UID : this.form.qoutetoken,
        currency_from: this.form.calresponse.from.toUpperCase(),
        currency_to : this.form.calresponse.to.toUpperCase(),
        amount: this.form.calresponse.amountFrom,
        receive: this.form.calresponse.amountTo,
        rate: this.form.calresponse.rate
      }
      this.$refs.reviewratedialog.show('autofx', paymentReceipt)
    }
  },
  async created(){
    this.getServiceActive()
    //await this.getBankAccount()
  }
};
</script>
<style></style>
